import xhrService from "../api";

export const dashboard = {
  fetch: (path) => {
    return xhrService.get(`/api${path}`).then(res => res.data);
  },
};

export default dashboard;
